// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__owhAx","log":"ModalInventoryLogs_log__3P-xM","date":"ModalInventoryLogs_date__rxKAs","userName":"ModalInventoryLogs_userName__3Cdcq"};